export enum AiSubjectLineTone {
  FRIENDLY = "Friendly",
  URGENT = "Urgent",
  EXCITING = "Exciting",
  PROFESSIONAL = "Professional",
  PERSONAL = "Personal",
  EXCLUSIVE = "Exclusive",
  PLAYFUL = "Playful",
  INFORMATIVE = "Informative",
  GRATEFUL = "Grateful",
  CURIOSITY = "Curiosity",
}

export const aiSubjectLineTones: AiSubjectLineTone[] = [
  AiSubjectLineTone.FRIENDLY,
  AiSubjectLineTone.URGENT,
  AiSubjectLineTone.EXCITING,
  AiSubjectLineTone.PROFESSIONAL,
  AiSubjectLineTone.PERSONAL,
  AiSubjectLineTone.EXCLUSIVE,
  AiSubjectLineTone.PLAYFUL,
  AiSubjectLineTone.INFORMATIVE,
  AiSubjectLineTone.GRATEFUL,
  AiSubjectLineTone.CURIOSITY,
];
